export default __webpack_public_path__ + "static/media/wiretransfer.d16dc46b.svg";